var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.93913 0 6.92172 0.421427 6.17157 1.17157C5.42143 1.92172 5 2.93913 5 4C5 5.06087 5.42143 6.07828 6.17157 6.82843C6.92172 7.57857 7.93913 8 9 8C10.0609 8 11.0783 7.57857 11.8284 6.82843C12.5786 6.07828 13 5.06087 13 4C13 2.93913 12.5786 1.92172 11.8284 1.17157C11.0783 0.421427 10.0609 0 9 0ZM15 9C11.7 9 9 11.7 9 15C9 18.3 11.7 21 15 21C18.3 21 21 18.3 21 15C21 11.7 18.3 9 15 9ZM8.05078 11.0469C4.89078 11.3089 0 12.796 0 15.5V18H7.58789C7.21189 17.073 7 16.062 7 15C7 13.56 7.38478 12.2139 8.05078 11.0469ZM15 12C15.552 12 16 12.448 16 13V14H17C17.552 14 18 14.448 18 15C18 15.552 17.552 16 17 16H16V17C16 17.552 15.552 18 15 18C14.448 18 14 17.552 14 17V16H13C12.448 16 12 15.552 12 15C12 14.448 12.448 14 13 14H14V13C14 12.448 14.448 12 15 12Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnvite);
export default __webpack_public_path__ + "static/media/innvite.09888f54f79db6aafca9b94bcad1a74b.svg";
export { ForwardRef as ReactComponent };